// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".resource-selector .resource-selector--head{height:43px}", "",{"version":3,"sources":["webpack://./resources/assets/admin/js/components/ResourceSelector.vue"],"names":[],"mappings":"AAEI,4CACI,WAAA","sourcesContent":["\n.resource-selector {\n    .resource-selector--head {\n        height: 43px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
